import React, { useState } from "react";
import Card, { CardProps } from "@mui/material/Card";
import Divider from "@mui/material/Divider";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import CardActionArea from "@mui/material/CardActionArea";
import Collapse from "@mui/material/Collapse";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

const DetailsCard: React.FC<{
    cardTitle: React.ReactNode;
    enableContentHiding?: boolean;
    defaultHidden?: boolean;
    cardProps?: CardProps;
    children: React.ReactNode;
}> = ({ cardTitle, enableContentHiding, cardProps, defaultHidden, children }) => {
    const [hideContent, setHideContent] = useState(defaultHidden);

    const hideContentToggleHandler = () => {
        setHideContent((previousState) => !previousState);
    };

    return (
        <Card {...cardProps} sx={{width: "100%"}}>
            <Stack>
                <CardActionArea disabled={!enableContentHiding} onClick={hideContentToggleHandler}>
                    <Stack direction="row" alignItems="center" justifyContent="space-between" p={2}>
                        {typeof cardTitle === "string" ? <Typography variant="h3">{cardTitle}</Typography> : cardTitle}
                        {enableContentHiding &&
                            (!hideContent ? <ExpandLessIcon color="action" /> : <ExpandMoreIcon color="action" />)}
                    </Stack>
                </CardActionArea>
                <Collapse in={!hideContent} sx={{ px: 2 }}>
                    <Divider sx={{ mb: 1 }} />
                    {children}
                </Collapse>
            </Stack>
        </Card>
    );
};

export default DetailsCard;
